interface ImpersonationTokenPayload {
  impersonatedBy?: string;
  id?: string;
  [key: string]: unknown;
}

export function parseImpersonationToken(token: string): ImpersonationTokenPayload | null {
  try {
    const [, b64] = token.split(".");
    return JSON.parse(atob(b64.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}
